export default __webpack_public_path__ + "static/media/droneAppRecommendation.f062208d.pdf";